import { render, staticRenderFns } from "./resources-inactive.component.html?vue&type=template&id=4e0d1d84&scoped=true&external"
import script from "./resources-inactive.component.ts?vue&type=script&lang=ts&external"
export * from "./resources-inactive.component.ts?vue&type=script&lang=ts&external"
import style0 from "./resources-inactive.component.scss?vue&type=style&index=0&id=4e0d1d84&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0d1d84",
  null
  
)

export default component.exports